import I18n from 'i18n-js';
import fr from './fr.json';

// Init translations
I18n.fallbacks = true;
I18n.locale = 'fr';
I18n.defaultLocale = 'fr';

I18n.translations = {
    fr: { ...fr },
};

// Don't fail silently
I18n.missingTranslation = function onMissingTranslation(key) {
    throw new Error(`Missing translation key "${key}".`);
};

export default I18n;
